import { render, staticRenderFns } from "./serveMunePopleDialog.vue?vue&type=template&id=b2843980&scoped=true"
import script from "./serveMunePopleDialog.vue?vue&type=script&lang=js"
export * from "./serveMunePopleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2843980",
  null
  
)

export default component.exports